import type { PortalApplication } from '../../model/portalModels';
import type { PortalOperationIdentity, PortalOperationResponse } from '../../modules/operations/types/portal.types';
import type { MobileBusinessApp, MobileOperation } from '../types';

export const operationIdentity = (value: PortalOperationIdentity) => JSON.stringify([value.applicationCode, value.operationCode]);
export function applicationModel(app: PortalApplication): MobileBusinessApp {
  return { code: app.appCode, name: app.appName, description: app.description ?? '', status: app.status };
}
export function operationModel(item: PortalOperationResponse): MobileOperation {
  return { id: operationIdentity(item), name: item.name, source: item.sourceApplication.applicationName,
    appCode: item.applicationCode, operationCode: item.operationCode,
    enabled: item.availability.available, unavailableReason: item.availability.message };
}
